[
  {
    "date": "2025-12-12 21:15:00",
    "open": 0.000015,
    "low": 0.0000149,
    "high": 0.0000152,
    "close": 0.0000151,
    "volume": 60576067
  },
  {
    "date": "2025-12-12 21:30:00",
    "open": 0.0000151,
    "low": 0.000015,
    "high": 0.0000153,
    "close": 0.0000152,
    "volume": 43427738
  },
  {
    "date": "2025-12-12 21:45:00",
    "open": 0.0000152,
    "low": 0.0000151,
    "high": 0.000018,
    "close": 0.0000166,
    "volume": 167975096
  },
  {
    "date": "2025-12-12 22:00:00",
    "open": 0.0000166,
    "low": 0.0000163,
    "high": 0.0000166,
    "close": 0.0000165,
    "volume": 45350231
  },
  {
    "date": "2025-12-12 22:15:00",
    "open": 0.0000165,
    "low": 0.0000163,
    "high": 0.0000167,
    "close": 0.0000164,
    "volume": 53527770
  },
  {
    "date": "2025-12-12 22:30:00",
    "open": 0.0000164,
    "low": 0.0000162,
    "high": 0.0000166,
    "close": 0.0000163,
    "volume": 44958268
  },
  {
    "date": "2025-12-12 22:45:00",
    "open": 0.0000163,
    "low": 0.0000161,
    "high": 0.0000164,
    "close": 0.0000162,
    "volume": 41908857
  },
  {
    "date": "2025-12-12 23:00:00",
    "open": 0.0000162,
    "low": 0.0000162,
    "high": 0.0000162,
    "close": 0.0000162,
    "volume": 54941330
  },
  {
    "date": "2025-12-12 23:15:00",
    "open": 0.0000162,
    "low": 0.0000158,
    "high": 0.0000164,
    "close": 0.000016,
    "volume": 52191913
  },
  {
    "date": "2025-12-12 23:30:00",
    "open": 0.000016,
    "low": 0.0000159,
    "high": 0.0000163,
    "close": 0.0000163,
    "volume": 51855040
  },
  {
    "date": "2025-12-12 23:45:00",
    "open": 0.0000163,
    "low": 0.000016,
    "high": 0.0000172,
    "close": 0.0000166,
    "volume": 64600424
  },
  {
    "date": "2025-12-13 00:00:00",
    "open": 0.0000166,
    "low": 0.0000161,
    "high": 0.0000226,
    "close": 0.0000187,
    "volume": 175797573
  },
  {
    "date": "2025-12-13 00:15:00",
    "open": 0.0000187,
    "low": 0.0000185,
    "high": 0.0000188,
    "close": 0.0000186,
    "volume": 44321642
  },
  {
    "date": "2025-12-13 00:30:00",
    "open": 0.0000186,
    "low": 0.0000185,
    "high": 0.0000188,
    "close": 0.0000187,
    "volume": 52154136
  },
  {
    "date": "2025-12-13 00:45:00",
    "open": 0.0000187,
    "low": 0.0000185,
    "high": 0.0000193,
    "close": 0.000019,
    "volume": 54117702
  },
  {
    "date": "2025-12-13 01:00:00",
    "open": 0.000019,
    "low": 0.000019,
    "high": 0.000019,
    "close": 0.000019,
    "volume": 44225462
  },
  {
    "date": "2025-12-13 01:15:00",
    "open": 0.000019,
    "low": 0.0000188,
    "high": 0.0000192,
    "close": 0.0000189,
    "volume": 40363784
  },
  {
    "date": "2025-12-13 01:30:00",
    "open": 0.0000189,
    "low": 0.0000144,
    "high": 0.0000232,
    "close": 0.0000151,
    "volume": 173097815
  },
  {
    "date": "2025-12-13 01:45:00",
    "open": 0.0000151,
    "low": 0.0000134,
    "high": 0.0000158,
    "close": 0.000014,
    "volume": 102358319
  },
  {
    "date": "2025-12-13 02:00:00",
    "open": 0.000014,
    "low": 0.000014,
    "high": 0.000014,
    "close": 0.000014,
    "volume": 40385275
  },
  {
    "date": "2025-12-13 02:15:00",
    "open": 0.000014,
    "low": 0.000014,
    "high": 0.000014,
    "close": 0.000014,
    "volume": 40874221
  },
  {
    "date": "2025-12-13 02:30:00",
    "open": 0.000014,
    "low": 0.000014,
    "high": 0.000014,
    "close": 0.000014,
    "volume": 63207169
  },
  {
    "date": "2025-12-13 02:45:00",
    "open": 0.000014,
    "low": 0.0000132,
    "high": 0.0000179,
    "close": 0.0000158,
    "volume": 177970663
  },
  {
    "date": "2025-12-13 03:00:00",
    "open": 0.0000158,
    "low": 0.0000151,
    "high": 0.000017,
    "close": 0.0000165,
    "volume": 154035159
  },
  {
    "date": "2025-12-13 03:15:00",
    "open": 0.0000165,
    "low": 0.0000157,
    "high": 0.000017,
    "close": 0.0000162,
    "volume": 53584992
  },
  {
    "date": "2025-12-13 03:30:00",
    "open": 0.0000162,
    "low": 0.0000161,
    "high": 0.0000164,
    "close": 0.0000163,
    "volume": 41755983
  },
  {
    "date": "2025-12-13 03:45:00",
    "open": 0.0000163,
    "low": 0.0000162,
    "high": 0.0000165,
    "close": 0.0000164,
    "volume": 41092155
  },
  {
    "date": "2025-12-13 04:00:00",
    "open": 0.0000164,
    "low": 0.0000164,
    "high": 0.0000164,
    "close": 0.0000164,
    "volume": 56889560
  },
  {
    "date": "2025-12-13 04:15:00",
    "open": 0.0000164,
    "low": 0.0000164,
    "high": 0.0000164,
    "close": 0.0000164,
    "volume": 48257740
  },
  {
    "date": "2025-12-13 04:30:00",
    "open": 0.0000164,
    "low": 0.0000163,
    "high": 0.0000167,
    "close": 0.0000165,
    "volume": 62948129
  },
  {
    "date": "2025-12-13 04:45:00",
    "open": 0.0000165,
    "low": 0.0000164,
    "high": 0.0000168,
    "close": 0.0000166,
    "volume": 57944029
  },
  {
    "date": "2025-12-13 05:00:00",
    "open": 0.0000166,
    "low": 0.0000158,
    "high": 0.0000167,
    "close": 0.0000162,
    "volume": 135554000
  },
  {
    "date": "2025-12-13 05:15:00",
    "open": 0.0000162,
    "low": 0.000016,
    "high": 0.0000164,
    "close": 0.0000163,
    "volume": 62028485
  },
  {
    "date": "2025-12-13 05:30:00",
    "open": 0.0000163,
    "low": 0.0000155,
    "high": 0.0000179,
    "close": 0.0000169,
    "volume": 117765959
  },
  {
    "date": "2025-12-13 05:45:00",
    "open": 0.0000169,
    "low": 0.0000167,
    "high": 0.0000176,
    "close": 0.0000172,
    "volume": 59004751
  },
  {
    "date": "2025-12-13 06:00:00",
    "open": 0.0000172,
    "low": 0.0000167,
    "high": 0.0000174,
    "close": 0.000017,
    "volume": 56178752
  },
  {
    "date": "2025-12-13 06:15:00",
    "open": 0.000017,
    "low": 0.0000169,
    "high": 0.0000171,
    "close": 0.0000169,
    "volume": 40658698
  },
  {
    "date": "2025-12-13 06:30:00",
    "open": 0.0000169,
    "low": 0.0000167,
    "high": 0.0000169,
    "close": 0.0000168,
    "volume": 47857236
  },
  {
    "date": "2025-12-13 06:45:00",
    "open": 0.0000168,
    "low": 0.0000168,
    "high": 0.0000168,
    "close": 0.0000168,
    "volume": 47332468
  },
  {
    "date": "2025-12-13 07:00:00",
    "open": 0.0000168,
    "low": 0.0000168,
    "high": 0.000017,
    "close": 0.0000169,
    "volume": 56063191
  },
  {
    "date": "2025-12-13 07:15:00",
    "open": 0.0000169,
    "low": 0.0000128,
    "high": 0.0000202,
    "close": 0.0000152,
    "volume": 113691467
  },
  {
    "date": "2025-12-13 07:30:00",
    "open": 0.0000152,
    "low": 0.0000151,
    "high": 0.000016,
    "close": 0.0000155,
    "volume": 59665402
  },
  {
    "date": "2025-12-13 07:45:00",
    "open": 0.0000155,
    "low": 0.0000155,
    "high": 0.0000155,
    "close": 0.0000155,
    "volume": 51378927
  },
  {
    "date": "2025-12-13 08:00:00",
    "open": 0.0000155,
    "low": 0.0000155,
    "high": 0.0000155,
    "close": 0.0000155,
    "volume": 130719441
  },
  {
    "date": "2025-12-13 08:15:00",
    "open": 0.0000155,
    "low": 0.0000153,
    "high": 0.0000159,
    "close": 0.0000157,
    "volume": 60377620
  },
  {
    "date": "2025-12-13 08:30:00",
    "open": 0.0000157,
    "low": 0.0000155,
    "high": 0.0000158,
    "close": 0.0000156,
    "volume": 43963984
  },
  {
    "date": "2025-12-13 08:45:00",
    "open": 0.0000156,
    "low": 0.0000156,
    "high": 0.0000156,
    "close": 0.0000156,
    "volume": 60528301
  },
  {
    "date": "2025-12-13 09:00:00",
    "open": 0.0000156,
    "low": 0.0000155,
    "high": 0.0000157,
    "close": 0.0000157,
    "volume": 41732765
  },
  {
    "date": "2025-12-13 09:15:00",
    "open": 0.0000157,
    "low": 0.0000154,
    "high": 0.0000161,
    "close": 0.0000155,
    "volume": 48712088
  },
  {
    "date": "2025-12-13 09:30:00",
    "open": 0.0000155,
    "low": 0.0000152,
    "high": 0.000016,
    "close": 0.0000157,
    "volume": 48979180
  },
  {
    "date": "2025-12-13 09:45:00",
    "open": 0.0000157,
    "low": 0.0000151,
    "high": 0.000016,
    "close": 0.0000155,
    "volume": 54827937
  },
  {
    "date": "2025-12-13 10:00:00",
    "open": 0.0000155,
    "low": 0.0000153,
    "high": 0.0000156,
    "close": 0.0000154,
    "volume": 51023758
  },
  {
    "date": "2025-12-13 10:15:00",
    "open": 0.0000154,
    "low": 0.0000153,
    "high": 0.0000161,
    "close": 0.0000157,
    "volume": 63724694
  },
  {
    "date": "2025-12-13 10:30:00",
    "open": 0.0000157,
    "low": 0.0000145,
    "high": 0.0000177,
    "close": 0.0000147,
    "volume": 118461709
  },
  {
    "date": "2025-12-13 10:45:00",
    "open": 0.0000147,
    "low": 0.0000145,
    "high": 0.0000149,
    "close": 0.0000146,
    "volume": 56880874
  },
  {
    "date": "2025-12-13 11:00:00",
    "open": 0.0000146,
    "low": 0.0000145,
    "high": 0.0000152,
    "close": 0.0000148,
    "volume": 43353937
  },
  {
    "date": "2025-12-13 11:15:00",
    "open": 0.0000148,
    "low": 0.0000145,
    "high": 0.0000149,
    "close": 0.0000146,
    "volume": 63812415
  },
  {
    "date": "2025-12-13 11:30:00",
    "open": 0.0000146,
    "low": 0.0000144,
    "high": 0.0000149,
    "close": 0.0000144,
    "volume": 49716799
  },
  {
    "date": "2025-12-13 11:45:00",
    "open": 0.0000144,
    "low": 0.0000142,
    "high": 0.0000146,
    "close": 0.0000143,
    "volume": 40983945
  },
  {
    "date": "2025-12-13 12:00:00",
    "open": 0.0000143,
    "low": 0.0000142,
    "high": 0.0000146,
    "close": 0.0000144,
    "volume": 40917804
  },
  {
    "date": "2025-12-13 12:15:00",
    "open": 0.0000144,
    "low": 0.0000141,
    "high": 0.0000145,
    "close": 0.0000143,
    "volume": 47044809
  },
  {
    "date": "2025-12-13 12:30:00",
    "open": 0.0000143,
    "low": 0.000014,
    "high": 0.0000156,
    "close": 0.0000149,
    "volume": 171213802
  },
  {
    "date": "2025-12-13 12:45:00",
    "open": 0.0000149,
    "low": 0.0000149,
    "high": 0.0000153,
    "close": 0.0000151,
    "volume": 58525053
  },
  {
    "date": "2025-12-13 13:00:00",
    "open": 0.0000151,
    "low": 0.0000143,
    "high": 0.0000156,
    "close": 0.0000148,
    "volume": 46552188
  },
  {
    "date": "2025-12-13 13:15:00",
    "open": 0.0000148,
    "low": 0.0000146,
    "high": 0.0000149,
    "close": 0.0000147,
    "volume": 40825205
  },
  {
    "date": "2025-12-13 13:30:00",
    "open": 0.0000147,
    "low": 0.0000142,
    "high": 0.0000153,
    "close": 0.0000142,
    "volume": 81170751
  },
  {
    "date": "2025-12-13 13:45:00",
    "open": 0.0000142,
    "low": 0.000014,
    "high": 0.0000142,
    "close": 0.000014,
    "volume": 51514626
  },
  {
    "date": "2025-12-13 14:00:00",
    "open": 0.000014,
    "low": 0.0000138,
    "high": 0.0000143,
    "close": 0.0000141,
    "volume": 55836101
  },
  {
    "date": "2025-12-13 14:15:00",
    "open": 0.0000141,
    "low": 0.0000141,
    "high": 0.0000141,
    "close": 0.0000141,
    "volume": 52943637
  },
  {
    "date": "2025-12-13 14:30:00",
    "open": 0.0000141,
    "low": 0.0000139,
    "high": 0.0000145,
    "close": 0.0000139,
    "volume": 40197592
  },
  {
    "date": "2025-12-13 14:45:00",
    "open": 0.0000139,
    "low": 0.0000135,
    "high": 0.0000145,
    "close": 0.0000141,
    "volume": 44582066
  },
  {
    "date": "2025-12-13 15:00:00",
    "open": 0.0000141,
    "low": 0.0000134,
    "high": 0.0000141,
    "close": 0.0000138,
    "volume": 53662965
  },
  {
    "date": "2025-12-13 15:15:00",
    "open": 0.0000138,
    "low": 0.0000138,
    "high": 0.0000138,
    "close": 0.0000138,
    "volume": 61037462
  },
  {
    "date": "2025-12-13 15:30:00",
    "open": 0.0000138,
    "low": 0.0000136,
    "high": 0.0000141,
    "close": 0.0000136,
    "volume": 56662595
  },
  {
    "date": "2025-12-13 15:45:00",
    "open": 0.0000136,
    "low": 0.0000133,
    "high": 0.000014,
    "close": 0.0000138,
    "volume": 46651648
  },
  {
    "date": "2025-12-13 16:00:00",
    "open": 0.0000138,
    "low": 0.0000138,
    "high": 0.0000138,
    "close": 0.0000138,
    "volume": 64009970
  },
  {
    "date": "2025-12-13 16:15:00",
    "open": 0.0000138,
    "low": 0.0000132,
    "high": 0.0000138,
    "close": 0.0000135,
    "volume": 43364051
  },
  {
    "date": "2025-12-13 16:30:00",
    "open": 0.0000135,
    "low": 0.0000134,
    "high": 0.000014,
    "close": 0.0000137,
    "volume": 59271243
  },
  {
    "date": "2025-12-13 16:45:00",
    "open": 0.0000137,
    "low": 0.0000134,
    "high": 0.0000139,
    "close": 0.0000136,
    "volume": 48891330
  },
  {
    "date": "2025-12-13 17:00:00",
    "open": 0.0000136,
    "low": 0.0000135,
    "high": 0.0000138,
    "close": 0.0000138,
    "volume": 56617699
  },
  {
    "date": "2025-12-13 17:15:00",
    "open": 0.0000138,
    "low": 0.0000136,
    "high": 0.0000144,
    "close": 0.0000141,
    "volume": 61767214
  },
  {
    "date": "2025-12-13 17:30:00",
    "open": 0.0000141,
    "low": 0.0000139,
    "high": 0.0000143,
    "close": 0.000014,
    "volume": 43657420
  },
  {
    "date": "2025-12-13 17:45:00",
    "open": 0.000014,
    "low": 0.000014,
    "high": 0.000014,
    "close": 0.000014,
    "volume": 44729571
  },
  {
    "date": "2025-12-13 18:00:00",
    "open": 0.000014,
    "low": 0.0000137,
    "high": 0.0000142,
    "close": 0.0000139,
    "volume": 49151248
  },
  {
    "date": "2025-12-13 18:15:00",
    "open": 0.0000139,
    "low": 0.0000134,
    "high": 0.000014,
    "close": 0.0000137,
    "volume": 47614335
  },
  {
    "date": "2025-12-13 18:30:00",
    "open": 0.0000137,
    "low": 0.0000133,
    "high": 0.000014,
    "close": 0.0000135,
    "volume": 44326898
  },
  {
    "date": "2025-12-13 18:45:00",
    "open": 0.0000135,
    "low": 0.0000135,
    "high": 0.0000135,
    "close": 0.0000135,
    "volume": 44250617
  },
  {
    "date": "2025-12-13 19:00:00",
    "open": 0.0000135,
    "low": 0.0000129,
    "high": 0.0000136,
    "close": 0.0000133,
    "volume": 63842630
  },
  {
    "date": "2025-12-13 19:15:00",
    "open": 0.0000133,
    "low": 0.0000131,
    "high": 0.0000135,
    "close": 0.0000134,
    "volume": 51753261
  },
  {
    "date": "2025-12-13 19:30:00",
    "open": 0.0000134,
    "low": 0.0000132,
    "high": 0.0000137,
    "close": 0.0000135,
    "volume": 45474530
  },
  {
    "date": "2025-12-13 19:45:00",
    "open": 0.0000135,
    "low": 0.0000133,
    "high": 0.0000137,
    "close": 0.0000134,
    "volume": 51563382
  },
  {
    "date": "2025-12-13 20:00:00",
    "open": 0.0000134,
    "low": 0.0000128,
    "high": 0.0000135,
    "close": 0.0000131,
    "volume": 45078416
  },
  {
    "date": "2025-12-13 20:15:00",
    "open": 0.0000131,
    "low": 0.000013,
    "high": 0.0000133,
    "close": 0.000013,
    "volume": 52451907
  },
  {
    "date": "2025-12-13 20:30:00",
    "open": 0.000013,
    "low": 0.0000126,
    "high": 0.0000134,
    "close": 0.0000128,
    "volume": 63073469
  },
  {
    "date": "2025-12-13 20:45:00",
    "open": 0.0000128,
    "low": 0.0000123,
    "high": 0.0000129,
    "close": 0.0000126,
    "volume": 62082100
  },
  {
    "date": "2025-12-13 21:00:00",
    "open": 0.0000126,
    "low": 0.0000126,
    "high": 0.0000126,
    "close": 0.0000126,
    "volume": 43296981
  },
  {
    "date": "2025-12-13 21:15:00",
    "open": 0.0000126,
    "low": 0.0000126,
    "high": 0.0000126,
    "close": 0.0000126,
    "volume": 61088054
  },
  {
    "date": "2025-12-13 21:30:00",
    "open": 0.0000126,
    "low": 0.0000123,
    "high": 0.0000131,
    "close": 0.0000128,
    "volume": 47492609
  },
  {
    "date": "2025-12-13 21:45:00",
    "open": 0.0000128,
    "low": 0.0000128,
    "high": 0.0000128,
    "close": 0.0000128,
    "volume": 52932153
  },
  {
    "date": "2025-12-13 22:00:00",
    "open": 0.0000128,
    "low": 0.0000122,
    "high": 0.0000132,
    "close": 0.0000126,
    "volume": 48730201
  },
  {
    "date": "2025-12-13 22:15:00",
    "open": 0.0000126,
    "low": 0.0000121,
    "high": 0.0000127,
    "close": 0.0000124,
    "volume": 42687951
  },
  {
    "date": "2025-12-13 22:30:00",
    "open": 0.0000124,
    "low": 0.0000122,
    "high": 0.0000127,
    "close": 0.0000122,
    "volume": 51471831
  },
  {
    "date": "2025-12-13 22:45:00",
    "open": 0.0000122,
    "low": 0.0000122,
    "high": 0.0000122,
    "close": 0.0000122,
    "volume": 63250853
  },
  {
    "date": "2025-12-13 23:00:00",
    "open": 0.0000122,
    "low": 0.0000122,
    "high": 0.0000124,
    "close": 0.0000123,
    "volume": 53335275
  },
  {
    "date": "2025-12-13 23:15:00",
    "open": 0.0000123,
    "low": 0.0000122,
    "high": 0.0000128,
    "close": 0.0000125,
    "volume": 41173727
  },
  {
    "date": "2025-12-13 23:30:00",
    "open": 0.0000125,
    "low": 0.0000122,
    "high": 0.0000126,
    "close": 0.0000124,
    "volume": 56127870
  },
  {
    "date": "2025-12-13 23:45:00",
    "open": 0.0000124,
    "low": 0.0000123,
    "high": 0.0000125,
    "close": 0.0000125,
    "volume": 58732788
  },
  {
    "date": "2025-12-14 00:00:00",
    "open": 0.0000125,
    "low": 0.0000121,
    "high": 0.000013,
    "close": 0.0000127,
    "volume": 42674732
  },
  {
    "date": "2025-12-14 00:15:00",
    "open": 0.0000127,
    "low": 0.0000127,
    "high": 0.0000127,
    "close": 0.0000127,
    "volume": 52558713
  },
  {
    "date": "2025-12-14 00:30:00",
    "open": 0.0000127,
    "low": 0.0000125,
    "high": 0.0000129,
    "close": 0.0000126,
    "volume": 51039931
  },
  {
    "date": "2025-12-14 00:45:00",
    "open": 0.0000126,
    "low": 0.0000122,
    "high": 0.0000128,
    "close": 0.0000124,
    "volume": 64046564
  },
  {
    "date": "2025-12-14 01:00:00",
    "open": 0.0000124,
    "low": 0.0000123,
    "high": 0.0000136,
    "close": 0.0000132,
    "volume": 87061815
  },
  {
    "date": "2025-12-14 01:15:00",
    "open": 0.0000132,
    "low": 0.000013,
    "high": 0.0000133,
    "close": 0.0000131,
    "volume": 59895566
  },
  {
    "date": "2025-12-14 01:30:00",
    "open": 0.0000131,
    "low": 0.0000131,
    "high": 0.0000131,
    "close": 0.0000131,
    "volume": 47630049
  },
  {
    "date": "2025-12-14 01:45:00",
    "open": 0.0000131,
    "low": 0.0000126,
    "high": 0.0000132,
    "close": 0.0000129,
    "volume": 42865617
  },
  {
    "date": "2025-12-14 02:00:00",
    "open": 0.0000129,
    "low": 0.0000127,
    "high": 0.0000131,
    "close": 0.0000128,
    "volume": 57588270
  },
  {
    "date": "2025-12-14 02:15:00",
    "open": 0.0000128,
    "low": 0.0000125,
    "high": 0.0000132,
    "close": 0.0000126,
    "volume": 54204395
  },
  {
    "date": "2025-12-14 02:30:00",
    "open": 0.0000126,
    "low": 0.0000124,
    "high": 0.0000129,
    "close": 0.0000127,
    "volume": 54020442
  },
  {
    "date": "2025-12-14 02:45:00",
    "open": 0.0000127,
    "low": 0.0000124,
    "high": 0.0000128,
    "close": 0.0000125,
    "volume": 60050758
  },
  {
    "date": "2025-12-14 03:00:00",
    "open": 0.0000125,
    "low": 0.0000122,
    "high": 0.0000151,
    "close": 0.0000135,
    "volume": 188544947
  },
  {
    "date": "2025-12-14 03:15:00",
    "open": 0.0000135,
    "low": 0.0000132,
    "high": 0.0000139,
    "close": 0.0000137,
    "volume": 41270858
  },
  {
    "date": "2025-12-14 03:30:00",
    "open": 0.0000137,
    "low": 0.0000136,
    "high": 0.000014,
    "close": 0.0000138,
    "volume": 56437649
  },
  {
    "date": "2025-12-14 03:45:00",
    "open": 0.0000138,
    "low": 0.0000136,
    "high": 0.0000139,
    "close": 0.0000137,
    "volume": 60197764
  },
  {
    "date": "2025-12-14 04:00:00",
    "open": 0.0000137,
    "low": 0.0000135,
    "high": 0.0000139,
    "close": 0.0000135,
    "volume": 47293335
  },
  {
    "date": "2025-12-14 04:15:00",
    "open": 0.0000135,
    "low": 0.0000134,
    "high": 0.0000137,
    "close": 0.0000136,
    "volume": 52122522
  },
  {
    "date": "2025-12-14 04:30:00",
    "open": 0.0000136,
    "low": 0.0000136,
    "high": 0.0000136,
    "close": 0.0000136,
    "volume": 63651191
  },
  {
    "date": "2025-12-14 04:45:00",
    "open": 0.0000136,
    "low": 0.0000134,
    "high": 0.0000139,
    "close": 0.0000137,
    "volume": 53959145
  },
  {
    "date": "2025-12-14 05:00:00",
    "open": 0.0000137,
    "low": 0.0000137,
    "high": 0.000014,
    "close": 0.0000138,
    "volume": 51870288
  },
  {
    "date": "2025-12-14 05:15:00",
    "open": 0.0000138,
    "low": 0.0000127,
    "high": 0.0000148,
    "close": 0.0000131,
    "volume": 180889460
  },
  {
    "date": "2025-12-14 05:30:00",
    "open": 0.0000131,
    "low": 0.000012,
    "high": 0.0000143,
    "close": 0.0000137,
    "volume": 116117120
  },
  {
    "date": "2025-12-14 05:45:00",
    "open": 0.0000137,
    "low": 0.0000134,
    "high": 0.0000138,
    "close": 0.0000136,
    "volume": 58386352
  },
  {
    "date": "2025-12-14 06:00:00",
    "open": 0.0000136,
    "low": 0.0000134,
    "high": 0.0000138,
    "close": 0.0000135,
    "volume": 45852182
  },
  {
    "date": "2025-12-14 06:15:00",
    "open": 0.0000135,
    "low": 0.0000133,
    "high": 0.0000136,
    "close": 0.0000134,
    "volume": 62600821
  },
  {
    "date": "2025-12-14 06:30:00",
    "open": 0.0000134,
    "low": 0.0000132,
    "high": 0.0000136,
    "close": 0.0000135,
    "volume": 44425645
  },
  {
    "date": "2025-12-14 06:45:00",
    "open": 0.0000135,
    "low": 0.0000132,
    "high": 0.0000137,
    "close": 0.0000137,
    "volume": 54686643
  },
  {
    "date": "2025-12-14 07:00:00",
    "open": 0.0000137,
    "low": 0.0000136,
    "high": 0.0000138,
    "close": 0.0000138,
    "volume": 45582543
  },
  {
    "date": "2025-12-14 07:15:00",
    "open": 0.0000138,
    "low": 0.0000107,
    "high": 0.0000139,
    "close": 0.0000125,
    "volume": 155749591
  },
  {
    "date": "2025-12-14 07:30:00",
    "open": 0.0000125,
    "low": 0.0000125,
    "high": 0.0000125,
    "close": 0.0000125,
    "volume": 64139460
  },
  {
    "date": "2025-12-14 07:45:00",
    "open": 0.0000125,
    "low": 0.0000123,
    "high": 0.0000127,
    "close": 0.0000126,
    "volume": 61807701
  },
  {
    "date": "2025-12-14 08:00:00",
    "open": 0.0000126,
    "low": 0.0000126,
    "high": 0.0000126,
    "close": 0.0000126,
    "volume": 41700675
  },
  {
    "date": "2025-12-14 08:15:00",
    "open": 0.0000126,
    "low": 0.0000122,
    "high": 0.0000129,
    "close": 0.0000124,
    "volume": 43290497
  },
  {
    "date": "2025-12-14 08:30:00",
    "open": 0.0000124,
    "low": 0.000012,
    "high": 0.0000129,
    "close": 0.0000126,
    "volume": 49412289
  },
  {
    "date": "2025-12-14 08:45:00",
    "open": 0.0000126,
    "low": 0.0000125,
    "high": 0.0000128,
    "close": 0.0000127,
    "volume": 42876765
  },
  {
    "date": "2025-12-14 09:00:00",
    "open": 0.0000127,
    "low": 0.0000126,
    "high": 0.0000132,
    "close": 0.000013,
    "volume": 53806381
  },
  {
    "date": "2025-12-14 09:15:00",
    "open": 0.000013,
    "low": 0.0000121,
    "high": 0.0000133,
    "close": 0.0000126,
    "volume": 153255610
  },
  {
    "date": "2025-12-14 09:30:00",
    "open": 0.0000126,
    "low": 0.0000114,
    "high": 0.0000129,
    "close": 0.0000122,
    "volume": 133932025
  },
  {
    "date": "2025-12-14 09:45:00",
    "open": 0.0000122,
    "low": 0.0000118,
    "high": 0.0000126,
    "close": 0.000012,
    "volume": 57322892
  },
  {
    "date": "2025-12-14 10:00:00",
    "open": 0.000012,
    "low": 0.000012,
    "high": 0.000012,
    "close": 0.000012,
    "volume": 51387769
  },
  {
    "date": "2025-12-14 10:15:00",
    "open": 0.000012,
    "low": 0.0000118,
    "high": 0.0000122,
    "close": 0.0000121,
    "volume": 47786652
  },
  {
    "date": "2025-12-14 10:30:00",
    "open": 0.0000121,
    "low": 0.0000105,
    "high": 0.0000122,
    "close": 0.0000113,
    "volume": 79665496
  },
  {
    "date": "2025-12-14 10:45:00",
    "open": 0.0000113,
    "low": 0.000011,
    "high": 0.0000116,
    "close": 0.0000111,
    "volume": 103684770
  },
  {
    "date": "2025-12-14 11:00:00",
    "open": 0.0000111,
    "low": 0.0000109,
    "high": 0.0000113,
    "close": 0.000011,
    "volume": 53829379
  },
  {
    "date": "2025-12-14 11:15:00",
    "open": 0.000011,
    "low": 0.000011,
    "high": 0.000011,
    "close": 0.000011,
    "volume": 51671254
  },
  {
    "date": "2025-12-14 11:30:00",
    "open": 0.000011,
    "low": 0.0000105,
    "high": 0.0000113,
    "close": 0.0000108,
    "volume": 54272239
  },
  {
    "date": "2025-12-14 11:45:00",
    "open": 0.0000108,
    "low": 0.0000106,
    "high": 0.0000113,
    "close": 0.000011,
    "volume": 42620729
  },
  {
    "date": "2025-12-14 12:00:00",
    "open": 0.000011,
    "low": 0.0000107,
    "high": 0.0000116,
    "close": 0.0000112,
    "volume": 62024846
  },
  {
    "date": "2025-12-14 12:15:00",
    "open": 0.0000112,
    "low": 0.0000112,
    "high": 0.0000114,
    "close": 0.0000113,
    "volume": 58032127
  },
  {
    "date": "2025-12-14 12:30:00",
    "open": 0.0000113,
    "low": 0.0000107,
    "high": 0.0000116,
    "close": 0.000011,
    "volume": 125029995
  },
  {
    "date": "2025-12-14 12:45:00",
    "open": 0.000011,
    "low": 0.000011,
    "high": 0.000011,
    "close": 0.000011,
    "volume": 58396501
  },
  {
    "date": "2025-12-14 13:00:00",
    "open": 0.000011,
    "low": 0.0000109,
    "high": 0.0000111,
    "close": 0.0000109,
    "volume": 58199670
  },
  {
    "date": "2025-12-14 13:15:00",
    "open": 0.0000109,
    "low": 0.0000094,
    "high": 0.0000112,
    "close": 0.0000103,
    "volume": 147529172
  },
  {
    "date": "2025-12-14 13:30:00",
    "open": 0.0000103,
    "low": 0.0000103,
    "high": 0.0000103,
    "close": 0.0000103,
    "volume": 58165622
  },
  {
    "date": "2025-12-14 13:45:00",
    "open": 0.0000103,
    "low": 0.0000101,
    "high": 0.0000103,
    "close": 0.0000102,
    "volume": 53444330
  },
  {
    "date": "2025-12-14 14:00:00",
    "open": 0.0000102,
    "low": 0.0000098,
    "high": 0.0000103,
    "close": 0.00001,
    "volume": 47593625
  },
  {
    "date": "2025-12-14 14:15:00",
    "open": 0.00001,
    "low": 0.00001,
    "high": 0.00001,
    "close": 0.00001,
    "volume": 49205668
  },
  {
    "date": "2025-12-14 14:30:00",
    "open": 0.00001,
    "low": 0.0000098,
    "high": 0.0000103,
    "close": 0.0000101,
    "volume": 58150913
  },
  {
    "date": "2025-12-14 14:45:00",
    "open": 0.0000101,
    "low": 0.0000099,
    "high": 0.0000103,
    "close": 0.00001,
    "volume": 62706355
  },
  {
    "date": "2025-12-14 15:00:00",
    "open": 0.00001,
    "low": 0.0000094,
    "high": 0.000012,
    "close": 0.0000107,
    "volume": 126757357
  },
  {
    "date": "2025-12-14 15:15:00",
    "open": 0.0000107,
    "low": 0.0000102,
    "high": 0.0000109,
    "close": 0.0000105,
    "volume": 48199389
  },
  {
    "date": "2025-12-14 15:30:00",
    "open": 0.0000105,
    "low": 0.0000102,
    "high": 0.0000106,
    "close": 0.0000104,
    "volume": 45112760
  },
  {
    "date": "2025-12-14 15:45:00",
    "open": 0.0000104,
    "low": 0.0000104,
    "high": 0.0000104,
    "close": 0.0000104,
    "volume": 43033666
  },
  {
    "date": "2025-12-14 16:00:00",
    "open": 0.0000104,
    "low": 0.0000103,
    "high": 0.0000106,
    "close": 0.0000105,
    "volume": 43648609
  },
  {
    "date": "2025-12-14 16:15:00",
    "open": 0.0000105,
    "low": 0.0000103,
    "high": 0.0000106,
    "close": 0.0000104,
    "volume": 60610446
  },
  {
    "date": "2025-12-14 16:30:00",
    "open": 0.0000104,
    "low": 0.0000103,
    "high": 0.0000106,
    "close": 0.0000105,
    "volume": 55770005
  },
  {
    "date": "2025-12-14 16:45:00",
    "open": 0.0000105,
    "low": 0.0000105,
    "high": 0.0000105,
    "close": 0.0000105,
    "volume": 52927819
  },
  {
    "date": "2025-12-14 17:00:00",
    "open": 0.0000105,
    "low": 0.0000103,
    "high": 0.0000106,
    "close": 0.0000106,
    "volume": 61061564
  },
  {
    "date": "2025-12-14 17:15:00",
    "open": 0.0000106,
    "low": 0.0000104,
    "high": 0.0000106,
    "close": 0.0000105,
    "volume": 50709107
  },
  {
    "date": "2025-12-14 17:30:00",
    "open": 0.0000105,
    "low": 0.00001,
    "high": 0.000011,
    "close": 0.0000101,
    "volume": 160304352
  },
  {
    "date": "2025-12-14 17:45:00",
    "open": 0.0000101,
    "low": 0.0000095,
    "high": 0.0000102,
    "close": 0.0000099,
    "volume": 53688383
  },
  {
    "date": "2025-12-14 18:00:00",
    "open": 0.0000099,
    "low": 0.0000097,
    "high": 0.00001,
    "close": 0.00001,
    "volume": 63614014
  },
  {
    "date": "2025-12-14 18:15:00",
    "open": 0.00001,
    "low": 0.0000098,
    "high": 0.0000104,
    "close": 0.0000102,
    "volume": 57038100
  },
  {
    "date": "2025-12-14 18:30:00",
    "open": 0.0000102,
    "low": 0.0000102,
    "high": 0.0000102,
    "close": 0.0000102,
    "volume": 45972477
  },
  {
    "date": "2025-12-14 18:45:00",
    "open": 0.0000102,
    "low": 0.00001,
    "high": 0.0000105,
    "close": 0.0000104,
    "volume": 57769782
  },
  {
    "date": "2025-12-14 19:00:00",
    "open": 0.0000104,
    "low": 0.0000103,
    "high": 0.0000108,
    "close": 0.0000106,
    "volume": 47709954
  },
  {
    "date": "2025-12-14 19:15:00",
    "open": 0.0000106,
    "low": 0.0000106,
    "high": 0.0000108,
    "close": 0.0000107,
    "volume": 50050533
  },
  {
    "date": "2025-12-14 19:30:00",
    "open": 0.0000107,
    "low": 0.0000105,
    "high": 0.0000109,
    "close": 0.0000106,
    "volume": 64906911
  },
  {
    "date": "2025-12-14 19:45:00",
    "open": 0.0000106,
    "low": 0.0000102,
    "high": 0.0000118,
    "close": 0.000011,
    "volume": 156160055
  },
  {
    "date": "2025-12-14 20:00:00",
    "open": 0.000011,
    "low": 0.0000104,
    "high": 0.0000114,
    "close": 0.0000108,
    "volume": 59778999
  },
  {
    "date": "2025-12-14 20:15:00",
    "open": 0.0000108,
    "low": 0.0000108,
    "high": 0.0000108,
    "close": 0.0000108,
    "volume": 58901081
  },
  {
    "date": "2025-12-14 20:30:00",
    "open": 0.0000108,
    "low": 0.0000107,
    "high": 0.0000111,
    "close": 0.0000109,
    "volume": 40000841
  },
  {
    "date": "2025-12-14 20:45:00",
    "open": 0.0000109,
    "low": 0.0000109,
    "high": 0.0000112,
    "close": 0.000011,
    "volume": 58047921
  },
  {
    "date": "2025-12-14 21:00:00",
    "open": 0.000011,
    "low": 0.000011,
    "high": 0.000011,
    "close": 0.000011,
    "volume": 124601533
  },
  {
    "date": "2025-12-14 21:15:00",
    "open": 0.000011,
    "low": 0.0000108,
    "high": 0.0000111,
    "close": 0.0000109,
    "volume": 41525161
  },
  {
    "date": "2025-12-14 21:30:00",
    "open": 0.0000109,
    "low": 0.0000107,
    "high": 0.0000112,
    "close": 0.0000111,
    "volume": 42447281
  },
  {
    "date": "2025-12-14 21:45:00",
    "open": 0.0000111,
    "low": 0.000011,
    "high": 0.0000113,
    "close": 0.0000112,
    "volume": 45095867
  },
  {
    "date": "2025-12-14 22:00:00",
    "open": 0.0000112,
    "low": 0.0000112,
    "high": 0.0000112,
    "close": 0.0000112,
    "volume": 61918121
  },
  {
    "date": "2025-12-14 22:15:00",
    "open": 0.0000112,
    "low": 0.000011,
    "high": 0.0000116,
    "close": 0.0000114,
    "volume": 62184295
  },
  {
    "date": "2025-12-14 22:30:00",
    "open": 0.0000114,
    "low": 0.0000112,
    "high": 0.0000115,
    "close": 0.0000113,
    "volume": 55522971
  },
  {
    "date": "2025-12-14 22:45:00",
    "open": 0.0000113,
    "low": 0.0000111,
    "high": 0.0000114,
    "close": 0.0000112,
    "volume": 41014459
  },
  {
    "date": "2025-12-14 23:00:00",
    "open": 0.0000112,
    "low": 0.000011,
    "high": 0.0000113,
    "close": 0.0000111,
    "volume": 49739551
  },
  {
    "date": "2025-12-14 23:15:00",
    "open": 0.0000111,
    "low": 0.000011,
    "high": 0.0000114,
    "close": 0.0000112,
    "volume": 57486764
  },
  {
    "date": "2025-12-14 23:30:00",
    "open": 0.0000112,
    "low": 0.0000111,
    "high": 0.0000113,
    "close": 0.0000113,
    "volume": 43281311
  },
  {
    "date": "2025-12-14 23:45:00",
    "open": 0.0000113,
    "low": 0.0000109,
    "high": 0.0000117,
    "close": 0.0000111,
    "volume": 142600772
  },
  {
    "date": "2025-12-15 00:00:00",
    "open": 0.0000111,
    "low": 0.000011,
    "high": 0.0000113,
    "close": 0.0000112,
    "volume": 46917084
  },
  {
    "date": "2025-12-15 00:15:00",
    "open": 0.0000112,
    "low": 0.000011,
    "high": 0.0000114,
    "close": 0.0000113,
    "volume": 41899083
  },
  {
    "date": "2025-12-15 00:30:00",
    "open": 0.0000113,
    "low": 0.0000112,
    "high": 0.0000115,
    "close": 0.0000114,
    "volume": 62003224
  },
  {
    "date": "2025-12-15 00:45:00",
    "open": 0.0000114,
    "low": 0.0000112,
    "high": 0.0000114,
    "close": 0.0000113,
    "volume": 52957862
  },
  {
    "date": "2025-12-15 01:00:00",
    "open": 0.0000113,
    "low": 0.0000112,
    "high": 0.0000116,
    "close": 0.0000114,
    "volume": 41485295
  },
  {
    "date": "2025-12-15 01:15:00",
    "open": 0.0000114,
    "low": 0.0000108,
    "high": 0.0000117,
    "close": 0.0000112,
    "volume": 51119339
  },
  {
    "date": "2025-12-15 01:30:00",
    "open": 0.0000112,
    "low": 0.000011,
    "high": 0.0000113,
    "close": 0.0000111,
    "volume": 101112056
  },
  {
    "date": "2025-12-15 01:45:00",
    "open": 0.0000111,
    "low": 0.000011,
    "high": 0.0000114,
    "close": 0.0000112,
    "volume": 49255859
  },
  {
    "date": "2025-12-15 02:00:00",
    "open": 0.0000112,
    "low": 0.0000109,
    "high": 0.0000116,
    "close": 0.0000114,
    "volume": 128358633
  },
  {
    "date": "2025-12-15 02:15:00",
    "open": 0.0000114,
    "low": 0.0000112,
    "high": 0.0000116,
    "close": 0.0000112,
    "volume": 63143445
  },
  {
    "date": "2025-12-15 02:30:00",
    "open": 0.0000112,
    "low": 0.000011,
    "high": 0.0000118,
    "close": 0.0000114,
    "volume": 49987896
  },
  {
    "date": "2025-12-15 02:45:00",
    "open": 0.0000114,
    "low": 0.0000111,
    "high": 0.0000115,
    "close": 0.0000113,
    "volume": 41492394
  },
  {
    "date": "2025-12-15 03:00:00",
    "open": 0.0000113,
    "low": 0.0000111,
    "high": 0.0000115,
    "close": 0.0000114,
    "volume": 47619360
  },
  {
    "date": "2025-12-15 03:15:00",
    "open": 0.0000114,
    "low": 0.0000111,
    "high": 0.0000118,
    "close": 0.0000116,
    "volume": 51189536
  },
  {
    "date": "2025-12-15 03:30:00",
    "open": 0.0000116,
    "low": 0.0000115,
    "high": 0.0000118,
    "close": 0.0000117,
    "volume": 45549762
  },
  {
    "date": "2025-12-15 03:45:00",
    "open": 0.0000117,
    "low": 0.0000086,
    "high": 0.000012,
    "close": 0.0000106,
    "volume": 139345050
  },
  {
    "date": "2025-12-15 04:00:00",
    "open": 0.0000106,
    "low": 0.0000106,
    "high": 0.0000106,
    "close": 0.0000106,
    "volume": 58857803
  },
  {
    "date": "2025-12-15 04:15:00",
    "open": 0.0000106,
    "low": 0.0000076,
    "high": 0.0000126,
    "close": 0.000009,
    "volume": 179923091
  },
  {
    "date": "2025-12-15 04:30:00",
    "open": 0.000009,
    "low": 0.0000088,
    "high": 0.0000091,
    "close": 0.0000089,
    "volume": 51247037
  },
  {
    "date": "2025-12-15 04:45:00",
    "open": 0.0000089,
    "low": 0.0000089,
    "high": 0.0000089,
    "close": 0.0000089,
    "volume": 62518952
  },
  {
    "date": "2025-12-15 05:00:00",
    "open": 0.0000089,
    "low": 0.0000088,
    "high": 0.0000091,
    "close": 0.0000088,
    "volume": 49783586
  },
  {
    "date": "2025-12-15 05:15:00",
    "open": 0.0000088,
    "low": 0.0000086,
    "high": 0.000009,
    "close": 0.0000089,
    "volume": 51532875
  },
  {
    "date": "2025-12-15 05:30:00",
    "open": 0.0000089,
    "low": 0.0000088,
    "high": 0.000009,
    "close": 0.000009,
    "volume": 40826086
  },
  {
    "date": "2025-12-15 05:45:00",
    "open": 0.000009,
    "low": 0.0000089,
    "high": 0.0000093,
    "close": 0.0000091,
    "volume": 44690873
  },
  {
    "date": "2025-12-15 06:00:00",
    "open": 0.0000091,
    "low": 0.0000091,
    "high": 0.0000091,
    "close": 0.0000091,
    "volume": 40215218
  },
  {
    "date": "2025-12-15 06:15:00",
    "open": 0.0000091,
    "low": 0.0000091,
    "high": 0.0000093,
    "close": 0.0000092,
    "volume": 45726630
  },
  {
    "date": "2025-12-15 06:30:00",
    "open": 0.0000092,
    "low": 0.0000091,
    "high": 0.0000092,
    "close": 0.0000091,
    "volume": 41827312
  },
  {
    "date": "2025-12-15 06:45:00",
    "open": 0.0000091,
    "low": 0.000009,
    "high": 0.0000094,
    "close": 0.0000092,
    "volume": 52825961
  },
  {
    "date": "2025-12-15 07:00:00",
    "open": 0.0000092,
    "low": 0.0000092,
    "high": 0.0000092,
    "close": 0.0000092,
    "volume": 54832308
  },
  {
    "date": "2025-12-15 07:15:00",
    "open": 0.0000092,
    "low": 0.0000091,
    "high": 0.0000093,
    "close": 0.0000093,
    "volume": 62906592
  },
  {
    "date": "2025-12-15 07:30:00",
    "open": 0.0000093,
    "low": 0.0000093,
    "high": 0.0000093,
    "close": 0.0000093,
    "volume": 52295870
  },
  {
    "date": "2025-12-15 07:45:00",
    "open": 0.0000093,
    "low": 0.0000092,
    "high": 0.0000096,
    "close": 0.0000094,
    "volume": 46031300
  },
  {
    "date": "2025-12-15 08:00:00",
    "open": 0.0000094,
    "low": 0.0000094,
    "high": 0.0000094,
    "close": 0.0000094,
    "volume": 53708623
  },
  {
    "date": "2025-12-15 08:15:00",
    "open": 0.0000094,
    "low": 0.0000083,
    "high": 0.00001,
    "close": 0.0000089,
    "volume": 142223669
  },
  {
    "date": "2025-12-15 08:30:00",
    "open": 0.0000089,
    "low": 0.0000089,
    "high": 0.0000089,
    "close": 0.0000089,
    "volume": 64177149
  },
  {
    "date": "2025-12-15 08:45:00",
    "open": 0.0000089,
    "low": 0.0000089,
    "high": 0.0000089,
    "close": 0.0000089,
    "volume": 64995298
  },
  {
    "date": "2025-12-15 09:00:00",
    "open": 0.0000089,
    "low": 0.0000087,
    "high": 0.0000091,
    "close": 0.0000088,
    "volume": 63697591
  },
  {
    "date": "2025-12-15 09:15:00",
    "open": 0.0000088,
    "low": 0.0000088,
    "high": 0.0000088,
    "close": 0.0000088,
    "volume": 63923787
  },
  {
    "date": "2025-12-15 09:30:00",
    "open": 0.0000088,
    "low": 0.0000086,
    "high": 0.0000089,
    "close": 0.0000087,
    "volume": 52599297
  },
  {
    "date": "2025-12-15 09:45:00",
    "open": 0.0000087,
    "low": 0.0000085,
    "high": 0.000009,
    "close": 0.0000088,
    "volume": 63495373
  },
  {
    "date": "2025-12-15 10:00:00",
    "open": 0.0000088,
    "low": 0.0000088,
    "high": 0.0000088,
    "close": 0.0000088,
    "volume": 55759615
  },
  {
    "date": "2025-12-15 10:15:00",
    "open": 0.0000088,
    "low": 0.0000086,
    "high": 0.0000089,
    "close": 0.0000087,
    "volume": 42009388
  },
  {
    "date": "2025-12-15 10:30:00",
    "open": 0.0000087,
    "low": 0.0000086,
    "high": 0.0000088,
    "close": 0.0000088,
    "volume": 64568614
  },
  {
    "date": "2025-12-15 10:45:00",
    "open": 0.0000088,
    "low": 0.0000084,
    "high": 0.0000093,
    "close": 0.000009,
    "volume": 60479976
  },
  {
    "date": "2025-12-15 11:00:00",
    "open": 0.000009,
    "low": 0.000009,
    "high": 0.000009,
    "close": 0.000009,
    "volume": 57593062
  },
  {
    "date": "2025-12-15 11:15:00",
    "open": 0.000009,
    "low": 0.0000087,
    "high": 0.0000092,
    "close": 0.0000089,
    "volume": 44788584
  },
  {
    "date": "2025-12-15 11:30:00",
    "open": 0.0000089,
    "low": 0.0000084,
    "high": 0.000009,
    "close": 0.0000087,
    "volume": 42661927
  },
  {
    "date": "2025-12-15 11:45:00",
    "open": 0.0000087,
    "low": 0.0000086,
    "high": 0.0000089,
    "close": 0.0000088,
    "volume": 44112417
  },
  {
    "date": "2025-12-15 12:00:00",
    "open": 0.0000088,
    "low": 0.0000088,
    "high": 0.0000088,
    "close": 0.0000088,
    "volume": 46378678
  },
  {
    "date": "2025-12-15 12:15:00",
    "open": 0.0000088,
    "low": 0.0000085,
    "high": 0.000009,
    "close": 0.0000087,
    "volume": 52714359
  },
  {
    "date": "2025-12-15 12:30:00",
    "open": 0.0000087,
    "low": 0.0000084,
    "high": 0.0000088,
    "close": 0.0000086,
    "volume": 63196755
  },
  {
    "date": "2025-12-15 12:45:00",
    "open": 0.0000086,
    "low": 0.0000085,
    "high": 0.0000088,
    "close": 0.0000085,
    "volume": 42834007
  },
  {
    "date": "2025-12-15 13:00:00",
    "open": 0.0000085,
    "low": 0.0000084,
    "high": 0.0000088,
    "close": 0.0000086,
    "volume": 61650800
  },
  {
    "date": "2025-12-15 13:15:00",
    "open": 0.0000086,
    "low": 0.0000084,
    "high": 0.0000087,
    "close": 0.0000085,
    "volume": 43765169
  },
  {
    "date": "2025-12-15 13:30:00",
    "open": 0.0000085,
    "low": 0.0000082,
    "high": 0.0000087,
    "close": 0.0000084,
    "volume": 57317622
  },
  {
    "date": "2025-12-15 13:45:00",
    "open": 0.0000084,
    "low": 0.0000083,
    "high": 0.0000086,
    "close": 0.0000085,
    "volume": 47439315
  },
  {
    "date": "2025-12-15 14:00:00",
    "open": 0.0000085,
    "low": 0.0000085,
    "high": 0.0000085,
    "close": 0.0000085,
    "volume": 56203941
  },
  {
    "date": "2025-12-15 14:15:00",
    "open": 0.0000085,
    "low": 0.0000085,
    "high": 0.0000085,
    "close": 0.0000085,
    "volume": 57286004
  },
  {
    "date": "2025-12-15 14:30:00",
    "open": 0.0000085,
    "low": 0.0000068,
    "high": 0.0000112,
    "close": 0.0000068,
    "volume": 162890559
  },
  {
    "date": "2025-12-15 14:45:00",
    "open": 0.0000068,
    "low": 0.0000068,
    "high": 0.0000068,
    "close": 0.0000068,
    "volume": 46258882
  },
  {
    "date": "2025-12-15 15:00:00",
    "open": 0.0000068,
    "low": 0.0000068,
    "high": 0.0000068,
    "close": 0.0000068,
    "volume": 56528956
  },
  {
    "date": "2025-12-15 15:15:00",
    "open": 0.0000068,
    "low": 0.0000068,
    "high": 0.0000068,
    "close": 0.0000068,
    "volume": 43424435
  },
  {
    "date": "2025-12-15 15:30:00",
    "open": 0.0000068,
    "low": 0.0000068,
    "high": 0.0000068,
    "close": 0.0000068,
    "volume": 40373463
  },
  {
    "date": "2025-12-15 15:45:00",
    "open": 0.0000068,
    "low": 0.0000066,
    "high": 0.000007,
    "close": 0.0000067,
    "volume": 44256552
  },
  {
    "date": "2025-12-15 16:00:00",
    "open": 0.0000067,
    "low": 0.0000067,
    "high": 0.0000067,
    "close": 0.0000067,
    "volume": 46732406
  },
  {
    "date": "2025-12-15 16:15:00",
    "open": 0.0000067,
    "low": 0.0000067,
    "high": 0.0000069,
    "close": 0.0000068,
    "volume": 61600427
  },
  {
    "date": "2025-12-15 16:30:00",
    "open": 0.0000068,
    "low": 0.0000067,
    "high": 0.000007,
    "close": 0.0000069,
    "volume": 47217510
  },
  {
    "date": "2025-12-15 16:45:00",
    "open": 0.0000069,
    "low": 0.0000068,
    "high": 0.000007,
    "close": 0.0000068,
    "volume": 53767591
  },
  {
    "date": "2025-12-15 17:00:00",
    "open": 0.0000068,
    "low": 0.0000057,
    "high": 0.0000077,
    "close": 0.0000063,
    "volume": 101232928
  },
  {
    "date": "2025-12-15 17:15:00",
    "open": 0.0000063,
    "low": 0.0000063,
    "high": 0.0000063,
    "close": 0.0000063,
    "volume": 42323188
  },
  {
    "date": "2025-12-15 17:30:00",
    "open": 0.0000063,
    "low": 0.0000063,
    "high": 0.0000063,
    "close": 0.0000063,
    "volume": 40093779
  },
  {
    "date": "2025-12-15 17:45:00",
    "open": 0.0000063,
    "low": 0.0000063,
    "high": 0.0000063,
    "close": 0.0000063,
    "volume": 48290662
  },
  {
    "date": "2025-12-15 18:00:00",
    "open": 0.0000063,
    "low": 0.0000061,
    "high": 0.0000066,
    "close": 0.0000064,
    "volume": 59879227
  },
  {
    "date": "2025-12-15 18:15:00",
    "open": 0.0000064,
    "low": 0.0000064,
    "high": 0.0000064,
    "close": 0.0000064,
    "volume": 56758336
  },
  {
    "date": "2025-12-15 18:30:00",
    "open": 0.0000064,
    "low": 0.0000064,
    "high": 0.0000066,
    "close": 0.0000065,
    "volume": 51781181
  },
  {
    "date": "2025-12-15 18:45:00",
    "open": 0.0000065,
    "low": 0.0000054,
    "high": 0.0000066,
    "close": 0.0000061,
    "volume": 99739675
  },
  {
    "date": "2025-12-15 19:00:00",
    "open": 0.0000061,
    "low": 0.000006,
    "high": 0.0000063,
    "close": 0.0000062,
    "volume": 78627525
  },
  {
    "date": "2025-12-15 19:15:00",
    "open": 0.0000062,
    "low": 0.0000059,
    "high": 0.0000062,
    "close": 0.0000061,
    "volume": 111767774
  },
  {
    "date": "2025-12-15 19:30:00",
    "open": 0.0000061,
    "low": 0.000006,
    "high": 0.0000062,
    "close": 0.0000062,
    "volume": 51060599
  },
  {
    "date": "2025-12-15 19:45:00",
    "open": 0.0000062,
    "low": 0.000005,
    "high": 0.0000067,
    "close": 0.0000058,
    "volume": 105121256
  },
  {
    "date": "2025-12-15 20:00:00",
    "open": 0.0000058,
    "low": 0.0000056,
    "high": 0.0000059,
    "close": 0.0000057,
    "volume": 63809993
  },
  {
    "date": "2025-12-15 20:15:00",
    "open": 0.0000057,
    "low": 0.0000056,
    "high": 0.0000058,
    "close": 0.0000056,
    "volume": 61685957
  },
  {
    "date": "2025-12-15 20:30:00",
    "open": 0.0000056,
    "low": 0.0000054,
    "high": 0.0000056,
    "close": 0.0000055,
    "volume": 44475655
  },
  {
    "date": "2025-12-15 20:45:00",
    "open": 0.0000055,
    "low": 0.0000055,
    "high": 0.0000055,
    "close": 0.0000055,
    "volume": 56844509
  },
  {
    "date": "2025-12-15 21:00:00",
    "open": 0.0000055,
    "low": 0.0000055,
    "high": 0.0000055,
    "close": 0.0000055,
    "volume": 50810786
  },
  {
    "date": "2025-12-15 21:15:00",
    "open": 0.0000055,
    "low": 0.0000055,
    "high": 0.0000055,
    "close": 0.0000055,
    "volume": 43618433
  },
  {
    "date": "2025-12-15 21:30:00",
    "open": 0.0000055,
    "low": 0.0000053,
    "high": 0.0000056,
    "close": 0.0000054,
    "volume": 41583748
  },
  {
    "date": "2025-12-15 21:45:00",
    "open": 0.0000054,
    "low": 0.0000054,
    "high": 0.0000054,
    "close": 0.0000054,
    "volume": 45831908
  },
  {
    "date": "2025-12-15 22:00:00",
    "open": 0.0000054,
    "low": 0.0000052,
    "high": 0.0000056,
    "close": 0.0000053,
    "volume": 63366408
  },
  {
    "date": "2025-12-15 22:15:00",
    "open": 0.0000053,
    "low": 0.0000053,
    "high": 0.0000053,
    "close": 0.0000053,
    "volume": 49074072
  },
  {
    "date": "2025-12-15 22:30:00",
    "open": 0.0000053,
    "low": 0.0000051,
    "high": 0.0000053,
    "close": 0.0000052,
    "volume": 56196040
  },
  {
    "date": "2025-12-15 22:45:00",
    "open": 0.0000052,
    "low": 0.000005,
    "high": 0.0000054,
    "close": 0.0000053,
    "volume": 54447853
  },
  {
    "date": "2025-12-15 23:00:00",
    "open": 0.0000053,
    "low": 0.000005,
    "high": 0.0000055,
    "close": 0.0000052,
    "volume": 117444221
  },
  {
    "date": "2025-12-15 23:15:00",
    "open": 0.0000052,
    "low": 0.0000051,
    "high": 0.0000053,
    "close": 0.0000051,
    "volume": 53680848
  },
  {
    "date": "2025-12-15 23:30:00",
    "open": 0.0000051,
    "low": 0.0000048,
    "high": 0.0000052,
    "close": 0.0000049,
    "volume": 137795716
  },
  {
    "date": "2025-12-15 23:45:00",
    "open": 0.0000049,
    "low": 0.0000049,
    "high": 0.0000049,
    "close": 0.0000049,
    "volume": 46591175
  },
  {
    "date": "2025-12-16 00:00:00",
    "open": 0.0000049,
    "low": 0.0000049,
    "high": 0.0000049,
    "close": 0.0000049,
    "volume": 48880573
  }
]